// extracted by mini-css-extract-plugin
module.exports = {"loadingImg":"loadingBackdrop_loadingImg__11aWm"};